// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import { api, webapi, userapi } from '@/utils/http'
import store from './store'
// [优化] 首页改为普通滚动，已移除 vue-fullpage.js / scrolloverflow
import './assets/responsive.css' // [优化] 全站公共响应式样式（在 speed.css 之后加载）
import VueCookies from 'vue-cookies'
import vshare from 'vshare'
import ToastPlugin  from "./mixins/toastPlugin";

Vue.use(vshare)
Vue.use(VueCookies)
Vue.use(ToastPlugin );

// Vue.prototype.$axios = axios;
// Vue.prototype.$api = api          // 用于调用 m.sitestar.cn 的接口
// Vue.prototype.$webapi = webapi    // 用于调用 jswebsite.sitestar.cn 的接口
// Vue.prototype.$userapi = userapi  // 用于调用 js.sitestar.cn 的接口

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js